import * as React from 'react';

import { ErrorIcon } from '@origin-digital/icon';
import { errorForm, fireNewRelicErrorEvent } from '@origin-digital/reporting-client';
import { Heading1, Text } from '@origin-digital/style-guide';
import { Box } from '@origin-digital/layout';

import * as content from './content.json';

interface IState {
  error?: Error;
}

export class ErrorMessage extends React.PureComponent<{}, IState> {
  public state: IState = {};

  public componentDidCatch(error: Error) {
    this.setState({ error });
  }

  public render() {
    const { children } = this.props;
    const { error } = this.state;

    if (error) {
      fireNewRelicErrorEvent(error);
      errorForm({
        errorCode: error.name,
        errorMessage: error.message
      });

      return (
        <Box data-id="error-message">
          <Box marginTop={8} marginBottom={8} display="flex" justifyContent="center">
            <ErrorIcon color="red" size={72} />
          </Box>
          <Heading1 text={content.title} align="center" marginBottom />
          <Text align="center">{content.message}</Text>
        </Box>
      );
    }

    return children;
  }
}

export default ErrorMessage;
